/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.ts to modify the generation of this file.

import dynamic from 'next/dynamic'


import * as ArticleHero from 'components/authorable/article/ArticleHero/ArticleHero';
const ArticleListing = {
  module: () => import('components/authorable/article/ArticleListing/ArticleListing'),
  element: () => dynamic(ArticleListing.module)
}
import * as FeaturedArticle from 'components/authorable/article/FeaturedArticle/FeaturedArticle';
import * as FeaturedArticleImage from 'components/authorable/article/FeaturedArticle/FeaturedArticleImage';
import * as FeaturedArticleText from 'components/authorable/article/FeaturedArticle/FeaturedArticleText';
import * as HealthLibraryArticle from 'components/authorable/article/HealthLibraryArticle/HealthLibraryArticle';
const NewsCards = {
  module: () => import('components/authorable/article/NewsCards/NewsCards'),
  element: () => dynamic(NewsCards.module)
}
const NewsReleases = {
  module: () => import('components/authorable/article/NewsReleases/NewsReleases'),
  element: () => dynamic(NewsReleases.module)
}
const RelatedArticles = {
  module: () => import('components/authorable/article/RelatedArticles/RelatedArticles'),
  element: () => dynamic(RelatedArticles.module)
}
import * as SpecifiedArticleListing from 'components/authorable/article/SpecifiedArticleListing/SpecifiedArticleListing';
import * as SpecifiedFeaturedArticle from 'components/authorable/article/SpecifiedFeaturedArticle/SpecifiedFeaturedArticle';
import * as SpecifiedFeaturedArticleImage from 'components/authorable/article/SpecifiedFeaturedArticle/SpecifiedFeaturedArticleImage';
import * as SpecifiedFeaturedArticleText from 'components/authorable/article/SpecifiedFeaturedArticle/SpecifiedFeaturedArticleText';
import * as ActionCardListing from 'components/authorable/cardListings/ActionCardListing/ActionCardListing';
import * as GeneralCardListing from 'components/authorable/cardListings/GeneralCardListing/GeneralCardListing';
import * as IconCardListing from 'components/authorable/cardListings/IconCardListing/IconCardListing';
import * as ImageCardListing from 'components/authorable/cardListings/ImageCardListing/ImageCardListing';
import * as InfographicCardListing from 'components/authorable/cardListings/InfographicCardListing/InfographicCardListing';
import * as PlanCardListing from 'components/authorable/cardListings/PlanCardListing/PlanCardListing';
import * as AccordionFAQItem from 'components/authorable/faqs/AccordionFAQList/AccordionFAQItem';
import * as AccordionFAQList from 'components/authorable/faqs/AccordionFAQList/AccordionFAQList';
import * as FAQCategoryListing from 'components/authorable/faqs/FAQCategoryListing/FAQCategoryListing';
const FAQResults = {
  module: () => import('components/authorable/faqs/FAQResults/FAQResults'),
  element: () => dynamic(FAQResults.module)
}
const Formstack = {
  module: () => import('components/authorable/forms/Formstack/Formstack'),
  element: () => dynamic(Formstack.module)
}
import * as Accordion from 'components/authorable/general/Accordion/Accordion';
import * as AccordionItem from 'components/authorable/general/Accordion/AccordionItem';
import * as AlertMessage from 'components/authorable/general/AlertMessage/AlertMessage';
import * as AlertMessageItem from 'components/authorable/general/AlertMessage/AlertMessageItem';
import * as ContentBlock from 'components/authorable/general/ContentBlock/ContentBlock';
const CountdownTimer = {
  module: () => import('components/authorable/general/CountdownTimer/CountdownTimer'),
  element: () => dynamic(CountdownTimer.module)
}
import * as CountupTimer from 'components/authorable/general/CountupTimer/CountupTimer';
import * as CtaComponent from 'components/authorable/general/CtaComponent/CtaComponent';
import * as FindDoctor from 'components/authorable/general/FindDoctor/FindDoctor';
import * as Headline from 'components/authorable/general/Headline/Headline';
import * as HeadlineWithCTA from 'components/authorable/general/HeadlineWithCTA/HeadlineWithCTA';
import * as IconBenefitsGrid from 'components/authorable/general/IconBenefitsGrid/IconBenefitsGrid';
import * as IconBenefitsGridItem from 'components/authorable/general/IconBenefitsGrid/IconBenefitsGridItem';
const IFrameComponent = {
  module: () => import('components/authorable/general/IFrameComponent/IFrameComponent'),
  element: () => dynamic(IFrameComponent.module)
}
import * as MediaComponent from 'components/authorable/general/MediaComponent/MediaComponent';
import * as MediaContact from 'components/authorable/general/MediaContact/MediaContact';
import * as MedicarePlanOptions from 'components/authorable/general/MedicarePlanOptions/MedicarePlanOptions';
const ModalContainer = {
  module: () => import('components/authorable/general/ModalContainer/ModalContainer'),
  element: () => dynamic(ModalContainer.module)
}
import * as PageScripts from 'components/authorable/general/PageScripts/PageScripts';
import * as ResourceLinks from 'components/authorable/general/ResourceLinks/ResourceLinks';
import * as TestimonialListing from 'components/authorable/general/TestimonialListing/TestimonialListing';
import * as LargeTestimonial from 'components/authorable/general/TestimonialWithImage/LargeTestimonial';
import * as LargeTestimonialImage from 'components/authorable/general/TestimonialWithImage/LargeTestimonialImage';
import * as TestimonialWithImage from 'components/authorable/general/TestimonialWithImage/TestimonialWithImage';
import * as HeroHeadline from 'components/authorable/hero/HeroHeadline/HeroHeadline';
import * as HeroStandard from 'components/authorable/hero/HeroStandard/HeroStandard';
import * as LayoutFourColumn from 'components/authorable/layout/LayoutComponents/LayoutFourColumn/LayoutFourColumn';
import * as LayoutThreeColumn from 'components/authorable/layout/LayoutComponents/LayoutThreeColumn/LayoutThreeColumn';
import * as LayoutTwoColumn from 'components/authorable/layout/LayoutComponents/LayoutTwoColumn/LayoutTwoColumn';
import * as LayoutWideLeft from 'components/authorable/layout/LayoutComponents/LayoutWideLeft/LayoutWideLeft';
import * as LayoutWideRight from 'components/authorable/layout/LayoutComponents/LayoutWideRight/LayoutWideRight';
import * as LayoutPageSection from 'components/authorable/layout/LayoutPageSection/LayoutPageSection';
import * as SubNavigation from 'components/authorable/navigation/SubNavigation/SubNavigation';
import * as ToggleNavigation from 'components/authorable/navigation/ToggleNavigation/ToggleNavigation';
import * as PlanSideBySideComparison from 'components/authorable/plan/PlanSideBySideComparison/PlanSideBySideComparison';
import * as PriorAuthLookup from 'components/authorable/priorAuthLookup/PriorAuthLookup';
import * as PriorAuthLookupAuthNullResults from 'components/authorable/priorAuthLookup/PriorAuthLookupAuthNullResults';
import * as PriorAuthLookupAuthTrueResults from 'components/authorable/priorAuthLookup/PriorAuthLookupAuthTrueResults';
import * as PriorAuthLookupDefaultResults from 'components/authorable/priorAuthLookup/PriorAuthLookupDefaultResults';
import * as PriorAuthLookupFalseResults from 'components/authorable/priorAuthLookup/PriorAuthLookupFalseResults';
import * as PriorAuthProcedureCodeLookup from 'components/authorable/priorAuthLookup/PriorAuthProcedureCodeLookup/PriorAuthProcedureCodeLookup';
import * as Banner from 'components/authorable/promo/Banner/Banner';
const DropdownOverlayComponent = {
  module: () => import('components/authorable/promo/DropdownOverlayComponent/DropdownOverlayComponent'),
  element: () => dynamic(DropdownOverlayComponent.module)
}
import * as HealthSherpa from 'components/authorable/promo/health-sherpa/HealthSherpa';
import * as LargeMediaPromo from 'components/authorable/promo/LargeMediaPromo/LargeMediaPromo';
import * as LargeMediaPromoImage from 'components/authorable/promo/LargeMediaPromo/LargeMediaPromoImage';
import * as LargeMediaPromoText from 'components/authorable/promo/LargeMediaPromo/LargeMediaPromoText';
import * as MediaPromo from 'components/authorable/promo/MediaPromo/MediaPromo';
import * as MultiColumnOverlayPromo from 'components/authorable/promo/MultiColumnOverlayPromo/MultiColumnOverlayPromo';
import * as Promo from 'components/authorable/promo/Promo/Promo';
import * as Screenmeet from 'components/authorable/screenmeet/Screenmeet';
import * as GlobalHeaderSearchBar from 'components/authorable/search/GlobalHeaderSearchBar/GlobalHeaderSearchBar';
import * as MobileGlobalHeaderSearchBar from 'components/authorable/search/GlobalHeaderSearchBar/MobileGlobalHeaderSearchBar';
const GlobalSearchResults = {
  module: () => import('components/authorable/search/GlobalSearchResults/GlobalSearchResults'),
  element: () => dynamic(GlobalSearchResults.module)
}
const MedicalPolicySearchResults = {
  module: () => import('components/authorable/search/MedicalPolicySearchResults/MedicalPolicySearchResults'),
  element: () => dynamic(MedicalPolicySearchResults.module)
}
import * as ProviderLiaisonSearch from 'components/authorable/search/ProviderLiaisonSearch/ProviderLiaisonSearch';
import * as SearchBar from 'components/authorable/search/SearchBar/SearchBar';
import * as SearchContainer from 'components/authorable/search/SearchContainer/SearchContainer';
import * as SearchOverlay from 'components/authorable/search/SearchOverlay/SearchOverlay';
import * as Breadcrumb from 'components/authorable/site/Breadcrumb/Breadcrumb';
import * as Footer from 'components/authorable/site/Footer/Footer';
import * as Header from 'components/authorable/site/Header/Header';
import * as HeaderBasic from 'components/authorable/site/HeaderBasic/HeaderBasic';
import * as LogoHeader from 'components/authorable/site/LogoHeader/LogoHeader';
import * as DocumentListing from 'components/authorable/table/DocumentListing/DocumentListing';
import * as RelativeLinkListing from 'components/authorable/table/RelativeLinkListing/RelativeLinkListing';
import * as TableComponent from 'components/authorable/table/TableComponent/TableComponent';
import * as TabViews from 'components/authorable/toggles/tabviews/TabViews';
import * as ToggleViews from 'components/authorable/toggles/toggleviews/ToggleViews';

const components = new Map();

components.set('ArticleHero', ArticleHero);
components.set('ArticleListing', ArticleListing);
components.set('FeaturedArticle', FeaturedArticle);
components.set('FeaturedArticleImage', FeaturedArticleImage);
components.set('FeaturedArticleText', FeaturedArticleText);
components.set('HealthLibraryArticle', HealthLibraryArticle);
components.set('NewsCards', NewsCards);
components.set('NewsReleases', NewsReleases);
components.set('RelatedArticles', RelatedArticles);
components.set('SpecifiedArticleListing', SpecifiedArticleListing);
components.set('SpecifiedFeaturedArticle', SpecifiedFeaturedArticle);
components.set('SpecifiedFeaturedArticleImage', SpecifiedFeaturedArticleImage);
components.set('SpecifiedFeaturedArticleText', SpecifiedFeaturedArticleText);
components.set('ActionCardListing', ActionCardListing);
components.set('GeneralCardListing', GeneralCardListing);
components.set('IconCardListing', IconCardListing);
components.set('ImageCardListing', ImageCardListing);
components.set('InfographicCardListing', InfographicCardListing);
components.set('PlanCardListing', PlanCardListing);
components.set('AccordionFAQItem', AccordionFAQItem);
components.set('AccordionFAQList', AccordionFAQList);
components.set('FAQCategoryListing', FAQCategoryListing);
components.set('FAQResults', FAQResults);
components.set('Formstack', Formstack);
components.set('Accordion', Accordion);
components.set('AccordionItem', AccordionItem);
components.set('AlertMessage', AlertMessage);
components.set('AlertMessageItem', AlertMessageItem);
components.set('ContentBlock', ContentBlock);
components.set('CountdownTimer', CountdownTimer);
components.set('CountupTimer', CountupTimer);
components.set('CtaComponent', CtaComponent);
components.set('FindDoctor', FindDoctor);
components.set('Headline', Headline);
components.set('HeadlineWithCTA', HeadlineWithCTA);
components.set('IconBenefitsGrid', IconBenefitsGrid);
components.set('IconBenefitsGridItem', IconBenefitsGridItem);
components.set('IFrameComponent', IFrameComponent);
components.set('MediaComponent', MediaComponent);
components.set('MediaContact', MediaContact);
components.set('MedicarePlanOptions', MedicarePlanOptions);
components.set('ModalContainer', ModalContainer);
components.set('PageScripts', PageScripts);
components.set('ResourceLinks', ResourceLinks);
components.set('TestimonialListing', TestimonialListing);
components.set('LargeTestimonial', LargeTestimonial);
components.set('LargeTestimonialImage', LargeTestimonialImage);
components.set('TestimonialWithImage', TestimonialWithImage);
components.set('HeroHeadline', HeroHeadline);
components.set('HeroStandard', HeroStandard);
components.set('LayoutFourColumn', LayoutFourColumn);
components.set('LayoutThreeColumn', LayoutThreeColumn);
components.set('LayoutTwoColumn', LayoutTwoColumn);
components.set('LayoutWideLeft', LayoutWideLeft);
components.set('LayoutWideRight', LayoutWideRight);
components.set('LayoutPageSection', LayoutPageSection);
components.set('SubNavigation', SubNavigation);
components.set('ToggleNavigation', ToggleNavigation);
components.set('PlanSideBySideComparison', PlanSideBySideComparison);
components.set('PriorAuthLookup', PriorAuthLookup);
components.set('PriorAuthLookupAuthNullResults', PriorAuthLookupAuthNullResults);
components.set('PriorAuthLookupAuthTrueResults', PriorAuthLookupAuthTrueResults);
components.set('PriorAuthLookupDefaultResults', PriorAuthLookupDefaultResults);
components.set('PriorAuthLookupFalseResults', PriorAuthLookupFalseResults);
components.set('PriorAuthProcedureCodeLookup', PriorAuthProcedureCodeLookup);
components.set('Banner', Banner);
components.set('DropdownOverlayComponent', DropdownOverlayComponent);
components.set('HealthSherpa', HealthSherpa);
components.set('LargeMediaPromo', LargeMediaPromo);
components.set('LargeMediaPromoImage', LargeMediaPromoImage);
components.set('LargeMediaPromoText', LargeMediaPromoText);
components.set('MediaPromo', MediaPromo);
components.set('MultiColumnOverlayPromo', MultiColumnOverlayPromo);
components.set('Promo', Promo);
components.set('Screenmeet', Screenmeet);
components.set('GlobalHeaderSearchBar', GlobalHeaderSearchBar);
components.set('MobileGlobalHeaderSearchBar', MobileGlobalHeaderSearchBar);
components.set('GlobalSearchResults', GlobalSearchResults);
components.set('MedicalPolicySearchResults', MedicalPolicySearchResults);
components.set('ProviderLiaisonSearch', ProviderLiaisonSearch);
components.set('SearchBar', SearchBar);
components.set('SearchContainer', SearchContainer);
components.set('SearchOverlay', SearchOverlay);
components.set('Breadcrumb', Breadcrumb);
components.set('Footer', Footer);
components.set('Header', Header);
components.set('HeaderBasic', HeaderBasic);
components.set('LogoHeader', LogoHeader);
components.set('DocumentListing', DocumentListing);
components.set('RelativeLinkListing', RelativeLinkListing);
components.set('TableComponent', TableComponent);
components.set('TabViews', TabViews);
components.set('ToggleViews', ToggleViews);

// Next.js 'dynamic' import and JavaScript 'dynamic' import are different.
// Next.js 'dynamic(...)' returns common 'React.ComponentType' while
// 'import('...')' returns 'Promise' that will resolve module.
// componentModule uses 'import(...)' because primary usage of it to get not only 'React Component' (default export) but all named exports.
// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/import#dynamic_imports
// componentFactory uses 'dynamic(...)' because primary usage of it to render 'React Component' (default export).
// See https://nextjs.org/docs/advanced-features/dynamic-import
// At the end you will have single preloaded script for each lazy loading module.

export function componentModule(componentName: string) {
  const component = components.get(componentName);

  // check that component is lazy loading module
  if (!component?.default && component?.module) {
    // return js dynamic import
    return component.module();
  }

  return component;
}
  
export function componentFactory(componentName: string) {
  const component = components.get(componentName);

  // check that component should be dynamically imported
  if (component?.element) {
    // return next.js dynamic import
    return component.element();
  }

  return component?.default || component;
}
